// Phase F.1.3 — Read-only in-memory ring buffer for button geometry snapshots.
// Captures data from fabricFactory and fabricSync render paths so the in-app
// diagnostic panel can display all relevant geometry without browser console.
// Buffer is capped to prevent memory bloat. NEVER modifies button behavior.

export interface ButtonSnapshot {
  timestamp: number;
  phase: string;
  elementId: string;
  text: string;
  textLen: number;
  fontSize: number | undefined;
  fontFamily: string | undefined;
  fontWeight: string | number | undefined;
  paddingX: number | undefined;
  storedWidth: number;
  storedHeight: number;
  bgWidth: number | undefined;
  bgHeight: number | undefined;
  bgLeft: number | undefined;
  bgTop: number | undefined;
  labelWidth: number | undefined;
  labelHeight: number | undefined;
  labelLeft: number | undefined;
  labelTop: number | undefined;
  labelInkLeft: number | undefined;
  labelInkRight: number | undefined;
  groupLeft: number | undefined;
  groupTop: number | undefined;
  groupWidth: number | undefined;
  groupHeight: number | undefined;
  fitChanged: boolean | undefined;
  fitNewWidth: number | undefined;
  note: string | undefined;
}

const MAX_SNAPSHOTS = 200;
const buffer: ButtonSnapshot[] = [];
const listeners = new Set<() => void>();

export function recordButtonSnapshot(snapshot: ButtonSnapshot): void {
  buffer.push(snapshot);
  if (buffer.length > MAX_SNAPSHOTS) {
    buffer.shift();
  }
  for (const listener of listeners) {
    try { listener(); } catch { /* swallow */ }
  }
}

export function getButtonSnapshots(): ButtonSnapshot[] {
  return [...buffer];
}

export function clearButtonSnapshots(): void {
  buffer.length = 0;
  for (const listener of listeners) {
    try { listener(); } catch { /* swallow */ }
  }
}

export function subscribeButtonSnapshots(listener: () => void): () => void {
  listeners.add(listener);
  return () => { listeners.delete(listener); };
}
